module.exports = __webpack_public_path__ + "d4c6f6a8bf292ed2f99258c9720ef046.svg";